import { render, staticRenderFns } from "./recommentlist.vue?vue&type=template&id=097caa6f&scoped=true"
import script from "./recommentlist.vue?vue&type=script&lang=js"
export * from "./recommentlist.vue?vue&type=script&lang=js"
import style0 from "./recommentlist.vue?vue&type=style&index=0&id=097caa6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097caa6f",
  null
  
)

export default component.exports